import type { GtmViewItemEvent } from '@vs-shop/schemas/gtm/view-item';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export default function sendViewItemEvent(gtmEvent: GtmViewItemEvent) {
  return sendGtmEvent(gtmEvent, true);
}
